export class SearchControlSelectObject {
    constructor(public id: any, public name: any) {
    }
}

/**
 * Defines a list of object that can be passed to a SelectControlComponent to select based in a list of objects with id,name.
 * i.e. MultiSelectControl uses this to avoid going to the server to get the selection object
 */
export class SearchControlSelectObjects {
    objects: SearchControlSelectObject[] = [];
    // used to define a notifyChange in filterModel
    notifyChange: boolean;
}
